// 4xx statuses that are the backend answering "what you asked for is not
// allowed right now" to something the user did: validation (400), conflict on
// a double submit or concurrent edit (409), oversized or wrong-format upload
// (413/415), semantic validation (422), entity locked by a running job (423).
// The UI owes the user a message for these (see the MutationCache onError in
// react-shared/src/features/root.tsx); Sentry does not need a copy.
//
// Deliberately NOT in the set: 401 (auth pipeline owns it), 403 (the UI should
// not have offered the action — permission drift worth seeing), 404 (dead link
// vs badly built URL, worth triaging), 405/429 and anything else unexpected.
export const USER_VERDICT_STATUSES: ReadonlySet<number> = new Set([
  400, 409, 413, 415, 422, 423,
]);
